import { BaseResponse, MessageResponse } from 'common/types/api'
import api from 'core/api'

import {
  IotDeviceApi,
  IotDeviceListParams,
  IotDeviceListResponse,
  IotHistoryParams,
  IotPreRegisterBody,
  IotPreRegisterData,
  IotRegisterBody,
  IotSensorHistoryResponse,
  IotThresholdRangeStatusData,
  IotUpdateDeviceBody,
  IotUpdateThresholdBody,
  IotUpdateSalinityBody,
  IotUpdateSalinityData,
} from './types'

export const getIotDevices = (params?: IotDeviceListParams) =>
  api.get<BaseResponse<IotDeviceListResponse>>('/iot/devices', { params })

export const getIotDevice = (deviceId: string) =>
  api.get<BaseResponse<IotDeviceApi>>(`/iot/devices/${deviceId}`)

export const getIotSensorHistory = (deviceId: string, params: IotHistoryParams) =>
  api.get<BaseResponse<IotSensorHistoryResponse>>(`/iot/devices/${deviceId}/sensors/history`, {
    params,
  })

export const preRegisterIotDevice = (body: IotPreRegisterBody) =>
  api.post<BaseResponse<IotPreRegisterData>>('/iot/devices/pre-register', body)

export const registerIotDevice = (body: IotRegisterBody) =>
  api.post<MessageResponse>('/iot/devices/register', body)

export const updateIotDevice = (deviceId: string, body: IotUpdateDeviceBody) =>
  api.patch<MessageResponse>(`/iot/devices/${deviceId}`, body)

export const updateIotThreshold = (deviceId: string, body: IotUpdateThresholdBody) =>
  api.patch<BaseResponse<IotThresholdRangeStatusData>>(
    `/iot/devices/${deviceId}/threshold`,
    body
  )

// Errors are shown by the salinity dialog (409 needs data.salinity), so skip
// the global error snackbar.
export const updateIotSalinity = (deviceId: string, body: IotUpdateSalinityBody) =>
  api.patch<BaseResponse<IotUpdateSalinityData>>(`/iot/devices/${deviceId}/salinity`, body, {
    silentError: true,
  })

export const getIotThresholdRangeStatus = (deviceId: string) =>
  api.get<BaseResponse<IotThresholdRangeStatusData>>(`/iot/devices/${deviceId}/range-status`)

export const deleteIotDevice = (deviceId: string) =>
  api.delete<MessageResponse>(`/iot/devices/${deviceId}`)
